import { z } from 'zod';

/**
 * What a subject must look like before it is saved.
 *
 * Mirrors the backend's `subjects.validation.ts` — the server is the authority,
 * these rules only save a round trip. Whether a name is the same subject as one
 * already on the list (Maths beside Mathematics) is the server's to say: it
 * knows the whole list and the short forms, and answers with the subject the
 * name clashes with.
 */

export const SUBJECT_CATEGORIES = ['CORE', 'ELECTIVE', 'LANGUAGE'] as const;

/** Letters in any script with their marks, digits, and . , ( ) & / ' - */
const NAME_PATTERN = /^[\p{L}\p{M}\p{N} .,()&/'-]+$/u;

export const subjectSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, 'That name is too short')
    .max(60, 'Keep the name under 60 characters')
    .regex(NAME_PATTERN, "Letters, numbers, spaces and . , ( ) & / ' - only"),
  category: z.enum(SUBJECT_CATEGORIES, {
    errorMap: () => ({ message: 'Choose core, elective or language' }),
  }),
});

export type SubjectFormValues = z.input<typeof subjectSchema>;

export const EMPTY_SUBJECT: SubjectFormValues = { name: '', category: 'CORE' };
